import {ASSESSMENTSTATUSES,TUTORINVOICESTATUSES, DAYS, GROUPSTATUSES, WORKTYPE,STUDENTINVOICESTATUSES} from "./constants";

export function days_formatter(day){

    return DAYS[day]
}
export function group_status_formatter(status){

    return GROUPSTATUSES[status]
}

export function assessment_status_formatter(status){

    return ASSESSMENTSTATUSES[status]
}
export function work_type_formatter(status){

    return WORKTYPE[status]
}
export function student_Invoice_status_formatter(status){

    return STUDENTINVOICESTATUSES[status]
}
export function tutor_Invoice_status_formatter(status){

    return TUTORINVOICESTATUSES[status]
}